<div class="header d-flex justify-content-between">
  <h4 for="label">{{ variables?.tenantsManagement }}</h4>
  <div style="display: flex;">
    <app-button typeBtn="primary" style="margin-left: 10px;" message="{{ variables?.addTenant }}"
      [textColor]="colorWhite" [color]="'var(--primary-color)'" (click)="openCreate()"></app-button>
  </div>
</div>

@if (isLoading && !loadError) {
<app-loader class="centerLoader pt-5"></app-loader>
}

@if (loadError && !isLoading) {
<app-error-message [errorMsg]="errorText"></app-error-message>
}

@if (!isLoading && !loadError) {
<div>
  <div class="estimates mb-5">
    <div class="mat-elevation-z0">
      <table mat-table [dataSource]="tenants">
        <ng-container matColumnDef="id">
          <th mat-header-cell style="flex-basis: 14%;" *matHeaderCellDef>
            <strong>{{ variables?.tenantIdField }}</strong>
          </th>
          <td mat-cell style="flex-basis: 14%;" *matCellDef="let row">{{ row.id }}</td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell style="flex-basis: 16%;" *matHeaderCellDef>
            <strong>{{ variables?.tenantNameField }}</strong>
          </th>
          <td mat-cell style="flex-basis: 16%;" *matCellDef="let row">{{ row.name }}</td>
        </ng-container>
        <ng-container matColumnDef="logo">
          <th mat-header-cell style="flex-basis: 8%;" *matHeaderCellDef>
            <strong>{{ variables?.tenantLogoField }}</strong>
          </th>
          <td mat-cell style="flex-basis: 8%;" *matCellDef="let row">
            <img *ngIf="row.logo" [src]="row.logo" style="max-height: 24px; max-width: 60px; object-fit: contain;">
          </td>
        </ng-container>
        <ng-container matColumnDef="mainColor">
          <th mat-header-cell style="flex-basis: 12%;" *matHeaderCellDef>
            <strong>{{ variables?.tenantMainColorField }}</strong>
          </th>
          <td mat-cell style="flex-basis: 12%;" *matCellDef="let row">
            <div *ngIf="row.mainColor" [style.backgroundColor]="row.mainColor"
              style="width: 20px; height: 20px; display: inline-block; border: 1px solid #ccc; vertical-align: middle; margin-right: 6px;"></div>
            {{ row.mainColor }}
          </td>
        </ng-container>
        <ng-container matColumnDef="secondaryColor">
          <th mat-header-cell style="flex-basis: 12%;" *matHeaderCellDef>
            <strong>{{ variables?.tenantSecondaryColorField }}</strong>
          </th>
          <td mat-cell style="flex-basis: 12%;" *matCellDef="let row">
            <div *ngIf="row.secondaryColor" [style.backgroundColor]="row.secondaryColor"
              style="width: 20px; height: 20px; display: inline-block; border: 1px solid #ccc; vertical-align: middle; margin-right: 6px;"></div>
            {{ row.secondaryColor }}
          </td>
        </ng-container>
        <ng-container matColumnDef="useSso">
          <th mat-header-cell style="flex-basis: 10%;" *matHeaderCellDef>
            <strong>{{ variables?.tenantLoginModeField }}</strong>
          </th>
          <td mat-cell style="flex-basis: 10%;" *matCellDef="let row">
            @if (row.useSso) {
              {{ variables?.tenantLoginSso }}
            } @else {
              {{ variables?.tenantLoginPassword }}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="active">
          <th mat-header-cell style="flex-basis: 8%;" *matHeaderCellDef>
            <strong>{{ variables?.active }}</strong>
          </th>
          <td mat-cell style="flex-basis: 8%;" *matCellDef="let row">
            @if (row.active) {
              {{ variables?.active }}
            } @else {
              {{ variables?.inactive }}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell style="flex-basis: 20%;" class="horizontal-center" *matHeaderCellDef>
            <strong>{{ variables?.actions }}</strong>
          </th>
          <td mat-cell style="flex-basis: 20%;" class="horizontal-center" *matCellDef="let row">
            <div class="action_buttons">

              <span (click)="openEdit(row)" class="action_buttons-item spanIntervals" [matTooltip]="variables?.editTenant"
                matTooltipPosition="above">
                <img src="../../../../assets/svg/EditWhite.svg" alt="" width="20px">
              </span>
              <span (click)="confirmToggleActive(row)" class="action_buttons-item spanIntervals"
                [matTooltip]="row.active ? variables?.deactivateTenant : variables?.activateTenant"
                matTooltipPosition="above">
                @if (row.active) {
                  <img src="../../../../assets/svg/De-attachmentWhite.svg" alt="" width="20px">
                } @else {
                  <img src="../../../../assets/svg/ActivateUserWhite.svg" alt="" width="20px">
                }
              </span>
              <span (click)="confirmDelete(row)" class="action_buttons-item spanIntervals" [matTooltip]="variables?.deleteTenant"
                matTooltipPosition="above">
                <img src="../../../../assets/svg/BinWhite.svg" alt="" width="20px">
              </span>
            </div>
          </td>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </table>
    </div>
  </div>
</div>
}
